import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';


export const getInspectionOtherDetails = (shumaID) => {
  const data = {shumaID: parseInt(shumaID, 10)};

  return axios.post(api.GET_INSPECTION_OTHER_DETAILS, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body
    })
    .catch((err) => {
      console.error('GET_INSPECTION_OTHER_DETAILS returns error:');
      console.error(err);
    });
};
